import { render, staticRenderFns } from "./SuspiciousTransaction.vue?vue&type=template&id=6b6c23ed&scoped=true"
import script from "./SuspiciousTransaction.vue?vue&type=script&lang=js"
export * from "./SuspiciousTransaction.vue?vue&type=script&lang=js"
import style0 from "./SuspiciousTransaction.vue?vue&type=style&index=0&id=6b6c23ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6c23ed",
  null
  
)

export default component.exports